import {
  DEFAULT_MAT_COLOR,
  FILTERS,
  FRAME_COLORS,
  type MATERIAL_TYPES,
  MATTING,
  type MatColorKey,
  MAT_COLORS,
} from '@mixtiles/web-backend-shared'

export const MIXED_SIZES = 'Mixed Sizes'
export const MIXED_COLORS = 'Mixed Colors'
export const MIXED_MATERIALS = 'Mixed Materials'

export type BulkMaterial = MATERIAL_TYPES | typeof MIXED_MATERIALS

export const OUT_OF_STOCK = 'Out of Stock'

export const BASE_STYLING = 'baseStyling'
export const FALLBACK_STYLE = {
  frameColor: FRAME_COLORS.BLACK,
  matting: MATTING.SHALLOW,
  filter: FILTERS.NONE,
  mattingColor: DEFAULT_MAT_COLOR as MatColorKey,
}

export const FALLBACK_NO_MAT_STYLE = {
  frameColor: FRAME_COLORS.BLACK,
  matting: MATTING.NONE,
  filter: FILTERS.NONE,
  mattingColor: MAT_COLORS.NONE as MatColorKey,
}

export const FALLBACK_NOT_CLASSIC_MATERIAL_STYLE = {
  frameColor: FRAME_COLORS.NONE,
  matting: MATTING.NONE,
  filter: FILTERS.NONE,
  mattingColor: MAT_COLORS.NONE as MatColorKey,
}

export const AUTO_SAVE_POPUP_KEY = 'auto-save-popup-shown'
